module.exports = __webpack_public_path__ + "static/media/S-12.0681b5ae.mp3";